import { AbsenceType } from '@lmc/ts-common'
import {
  FilterContainer,
  GroupedUsersMultiSelect,
  MultiSelect,
  RangePicker,
} from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import useUsersList from 'screens/Rostering/hooks/useUsersList'

type AbsencesFiltersProps = {
  all: boolean
  absenceTypes: AbsenceType[]
  value: Partial<any>
  onChange: (value: any) => void
}

const AbsencesFilters = ({
  absenceTypes,
  onChange,
  value,
  all,
}: AbsencesFiltersProps) => {
  const { t } = useTranslation()
  const absenceTypesOptions = absenceTypes?.map((absenceType) => ({
    value: absenceType.id,
    label: absenceType.name,
  }))

  const { users } = useUsersList({})

  const handleInputChange = (newValue: any) => {
    const updatedValue: any = {
      ...value,
      ...newValue,
    }
    onChange(updatedValue)
  }

  return (
    <FilterContainer title={t('FILTERS')}>
      <>
        <RangePicker
          value={value.rangePicker}
          onChange={(rangePicker) => handleInputChange({ rangePicker })}
        />
        {all && (
          <GroupedUsersMultiSelect
            users={users}
            title={t('TEAM_MEMBERS')}
            handleInputChange={(selectedOptions) =>
              handleInputChange({
                users: selectedOptions as string[],
              })
            }
          />
        )}
        <MultiSelectWide
          options={absenceTypesOptions}
          hasClear
          hasSearch
          hasSelectAll
          title={t('ABSENCE_TYPE')}
          onChange={(absenceType: unknown) =>
            handleInputChange({
              absenceType: absenceType as unknown as string[],
            })
          }
        />
      </>
    </FilterContainer>
  )
}

const MultiSelectWide = styled(MultiSelect)`
  min-width: 200px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    width: 100%;
  }
`

export default AbsencesFilters
